import { decodeAttFileName } from '@web-common/components/util/file';
var _ = require('xss/lib/util');
var xssParse = require('xss/lib/parser');
console.log(xssParse.parseTag.toString());
xssParse.parseTag = parseTag;
var xss = require('xss');
var { safeAttrValue: defaultSafeAttrValue, escapeAttrValue } = require('xss');
const defaultOptions = {
    whiteList: {
        b: [],
        span: [],
        br: [],
    },
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
};
export const safeDecodeAttFileName = (fileName, options = defaultOptions) => {
    try {
        const decodedFileName = decodeAttFileName(fileName);
        return xss(decodedFileName, options);
    }
    catch (error) {
        console.error('Error sanitizing filename:', error);
        return xss(fileName, options);
    }
};
export const safeHTML = (html, options = defaultOptions) => {
    try {
        return xss(html || '', options);
    }
    catch (error) {
        console.error('Error sanitizing HTML:', error);
        return '';
    }
};
export const emailPreviewXSSOptions = {
    whiteList: {
        a: ['href', 'title', 'target', 'rel', 'style', 'class', 'id'],
        b: ['style', 'class', 'id'],
        strong: ['style', 'class', 'id'],
        i: ['style', 'class', 'id'],
        em: ['style', 'class', 'id'],
        u: ['style', 'class', 'id'],
        s: ['style', 'class', 'id'],
        small: ['style', 'class', 'id'],
        sub: ['style', 'class', 'id'],
        sup: ['style', 'class', 'id'],
        span: ['style', 'class', 'id'],
        br: ['class', 'id'],
        hr: ['style', 'class', 'id'],
        div: ['style', 'class', 'id'],
        p: ['style', 'class', 'id'],
        h1: ['style', 'class', 'id'],
        h2: ['style', 'class', 'id'],
        h3: ['style', 'class', 'id'],
        h4: ['style', 'class', 'id'],
        h5: ['style', 'class', 'id'],
        h6: ['style', 'class', 'id'],
        blockquote: ['style', 'class', 'id'],
        pre: ['style', 'class', 'id'],
        code: ['style', 'class', 'id'],
        ul: ['style', 'class', 'id'],
        ol: ['style', 'class', 'id'],
        li: ['style', 'class', 'id'],
        table: ['style', 'width', 'height', 'border', 'cellpadding', 'cellspacing', 'align', 'class', 'id'],
        thead: ['style', 'class', 'id'],
        tbody: ['style', 'class', 'id'],
        tfoot: ['style', 'class', 'id'],
        tr: ['style', 'class', 'id'],
        th: ['style', 'colspan', 'rowspan', 'width', 'height', 'align', 'valign', 'class', 'id'],
        td: ['style', 'colspan', 'rowspan', 'width', 'height', 'align', 'valign', 'class', 'id'],
        img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'style', 'class', 'id'],
        style: ['type', 'media', 'class', 'id'],
    },
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'iframe', 'object', 'embed'],
    safeAttrValue(tag, name, value, cssFilter) {
        if (tag === 'img') {
            if (name === 'src') {
                const trimmed = (value || '').trim();
                if (/^cid:/i.test(trimmed)) {
                    return escapeAttrValue(trimmed);
                }
                return defaultSafeAttrValue(tag, name, value, cssFilter);
            }
            if (name === 'srcset') {
                const candidates = (value || '')
                    .split(',')
                    .map(s => s.trim())
                    .filter(Boolean);
                const sanitized = [];
                for (const c of candidates) {
                    const parts = c.split(/\s+/);
                    const url = parts[0] || '';
                    const descriptor = parts.slice(1).join(' ');
                    let allowedUrl = defaultSafeAttrValue(tag, 'src', url, cssFilter);
                    if (!allowedUrl) {
                        if (/^cid:/i.test(url)) {
                            allowedUrl = escapeAttrValue(url);
                        }
                    }
                    if (allowedUrl) {
                        sanitized.push(descriptor ? `${allowedUrl} ${descriptor}` : allowedUrl);
                    }
                }
                return escapeAttrValue(sanitized.join(', '));
            }
        }
        return defaultSafeAttrValue(tag, name, value, cssFilter);
    },
    escapeHtml(html, tagName) {
        var REGEXP_LT = /</g;
        var REGEXP_GT = />/g;
        if (tagName === 'style') {
            return html;
        }
        return html.replace(REGEXP_LT, '&lt;').replace(REGEXP_GT, '&gt;');
    },
    css: {
        whiteList: {
            color: true,
            background: true,
            'background-color': true,
            'background-image': true,
            'background-position': true,
            'background-repeat': true,
            border: true,
            'border-color': true,
            'border-style': true,
            'border-width': true,
            'border-radius': true,
            font: true,
            'font-family': true,
            'font-size': true,
            'font-style': true,
            'font-weight': true,
            'letter-spacing': true,
            'line-height': true,
            'text-align': true,
            'text-decoration': true,
            'text-indent': true,
            'word-break': true,
            'word-wrap': true,
            display: true,
            float: true,
            clear: true,
            margin: true,
            'margin-top': true,
            'margin-right': true,
            'margin-bottom': true,
            'margin-left': true,
            padding: true,
            'padding-top': true,
            'padding-right': true,
            'padding-bottom': true,
            'padding-left': true,
            width: true,
            height: true,
            'max-width': true,
            'max-height': true,
            'min-width': true,
            'min-height': true,
            'vertical-align': true,
            'white-space': true,
            'list-style': true,
            'list-style-type': true,
            'list-style-position': true,
        },
    },
};
export const safeEmailHTML = (html) => {
    try {
        return xss(html || '', emailPreviewXSSOptions);
    }
    catch (error) {
        console.error('Error sanitizing Email HTML:', error);
        return '';
    }
};
function getTagName(html) {
    var i = _.spaceIndex(html);
    var tagName;
    if (i === -1) {
        tagName = html.slice(1, -1);
    }
    else {
        tagName = html.slice(1, i + 1);
    }
    tagName = _.trim(tagName).toLowerCase();
    if (tagName.slice(0, 1) === '/')
        tagName = tagName.slice(1);
    if (tagName.slice(-1) === '/')
        tagName = tagName.slice(0, -1);
    return tagName;
}
function isClosing(html) {
    return html.slice(0, 2) === '</';
}
function parseTag(html, onTag, escapeHtml) {
    'use strict';
    var rethtml = '';
    var lastPos = 0;
    var tagStart = false;
    var quoteStart = false;
    var currentPos = 0;
    var len = html.length;
    var currentTagName = '';
    var currentHtml = '';
    chariterator: for (currentPos = 0; currentPos < len; currentPos++) {
        var c = html.charAt(currentPos);
        if (tagStart === false) {
            if (c === '<') {
                tagStart = currentPos;
                continue;
            }
        }
        else {
            if (quoteStart === false) {
                if (c === '<') {
                    rethtml += escapeHtml(html.slice(lastPos, currentPos));
                    tagStart = currentPos;
                    lastPos = currentPos;
                    continue;
                }
                if (c === '>' || currentPos === len - 1) {
                    currentHtml = html.slice(tagStart, currentPos + 1);
                    currentTagName = getTagName(currentHtml);
                    rethtml += escapeHtml(html.slice(lastPos, tagStart), currentTagName);
                    rethtml += onTag(tagStart, rethtml.length, currentTagName, currentHtml, isClosing(currentHtml));
                    lastPos = currentPos + 1;
                    tagStart = false;
                    continue;
                }
                if (c === '"' || c === "'") {
                    var i = 1;
                    var ic = html.charAt(currentPos - i);
                    while (ic.trim() === '' || ic === '=') {
                        if (ic === '=') {
                            quoteStart = c;
                            continue chariterator;
                        }
                        ic = html.charAt(currentPos - ++i);
                    }
                }
            }
            else {
                if (c === quoteStart) {
                    quoteStart = false;
                    continue;
                }
            }
        }
    }
    if (lastPos < len) {
        rethtml += escapeHtml(html.substr(lastPos));
    }
    return rethtml;
}
